import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery } from '@/hooks/search/search.gql.impl';
import * as Types from '@/types/bff/gql-schema';

const useGetKeywordSearchHospitalInfiniteQuery = <T>(
  variables: Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<
    Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery,
    AxiosError,
    T
  >,
) => {
  return useInfiniteQuery<Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery, AxiosError, T>(
    ['getDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage', variables],
    ({ pageParam }) => {
      return useGetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery.fetcher({
        request: {
          ...variables.request,
          ...pageParam,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.GetDiseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPageQuery) => {
        const size = variables.request.size as number;
        if (lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.elements.length < size) {
          return undefined;
        }

        return {
          pivot: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivot,
          pivotScore: lastPage.diseaseKeywordSearchedHospitalInfoWithReviewSummaryCursorPage.pivotScore,
        };
      },
    },
  );
};

export default useGetKeywordSearchHospitalInfiniteQuery;
